module.exports = __webpack_public_path__ + "static/img/market-front.e3ef613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market-front.png
// module id = ypw1
// module chunks = 1